import React, { useEffect, useState } from "react"

import { observer } from "mobx-react"

import { ListTypes } from "./types"
import { ListImageItem, ListTextItem } from "./components"
import ListHeading from "./components/ListHeading"
import { Box } from "@mui/material"
import { StyledAccordionList } from "./styles"
import { isMobile } from "utils/Global"

const List: React.FC<ListTypes> = (props) => {
  const { title, items, type, accordion = false, from } = props
  const [hidden, setHidden] = useState(accordion)
  const [labelWidth, setLabelWidth] = useState(null)
  const [widthsArray, setWidthsArray] = useState([])
  const updateLabelWidth = (value: number) => {
    setWidthsArray((oldArray) => [...oldArray, value])
  }

  useEffect(() => {
    const maxWidth = widthsArray.length > 0 ? Math.max(...widthsArray) : null
    setLabelWidth(maxWidth)
  }, [widthsArray])

  const buildList = ({ item, lastItem, index }) => {
    if (type === "IMAGE") {
      return (
        <ListImageItem
          key={item.key}
          subItems={item.subItems}
          hasBorder={item.hasBorder}
        />
      )
    } else if (type === "TEXT" || type === "LINK") {
      return (
        <ListTextItem
          key={item.key + index}
          subItems={item.subItems}
          hasBorder={item.hasBorder}
          labelIcon={item.labelIcon}
          hasPadding={true}
          onClick={item.onClick}
          labelWidth={labelWidth}
          updateLabelWidth={updateLabelWidth}
          hidden={hidden}
          show={!accordion}
          lastItem={lastItem}
          from={from}
          fromKey={item.key}
        />
      )
    }
  }

  return (
    <Box className="list-container">
      <Box onClick={() => setHidden(!hidden)}>
        <ListHeading
          title={title}
          caret={accordion ? (hidden ? "DOWN" : "UP") : "NONE"}
          variant={"SECONDARY"}
        />
      </Box>
      <StyledAccordionList
        className="accordion-list"
        display={
          hidden && accordion ? "none" : type === "IMAGE" ? "flex" : "block"
        }
        sx={
          type === "IMAGE"
            ? {
                marginTop: "16px",
                gap: (theme) => theme.spacing(2),
                flexWrap: "wrap",
                alignItems: isMobile ? "center" : "flex-start",
                flexDirection: isMobile ? "column" : "row",
              }
            : {}
        }
      >
        {items.map((item, index) => {
          return buildList({
            item,
            lastItem: items.length - 1 === index,
            index,
          })
        })}
      </StyledAccordionList>
    </Box>
  )
}

export default observer(List)
